import { Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

/**
 * @param {string} dataIndex - Nombre del campo en los datos.
 * @param {object} searchInput - ref del input (opcional).
 * @param {object} filtersRef - ref donde se almacenan los filtros para backend (opcional).
 * @param {boolean} enableLocalFilter - si se debe usar onFilter para filtrar localmente.
 * @param {function} onApply - callback opcional para refetch server-side al confirmar búsqueda.
 */
export const getColumnSearchProps = (
  dataIndex,
  searchInput,
  filtersRef,
  enableLocalFilter = true,
  onApply
) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={searchInput}
        placeholder={`Buscar`}
        value={selectedKeys[0]}
        onChange={(e) => {
          const val = e.target.value;
          setSelectedKeys(val ? [val] : []);
          if (filtersRef?.current) {
            filtersRef.current[dataIndex] = val;
          }
        }}
        onPressEnter={() => {
          if (filtersRef?.current) {
            filtersRef.current[dataIndex] = selectedKeys[0];
          }
          confirm();
          onApply?.();
        }}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => {
            if (filtersRef?.current) {
              filtersRef.current[dataIndex] = selectedKeys[0];
            }
            confirm();
            onApply?.();
          }}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            if (filtersRef?.current) {
              filtersRef.current[dataIndex] = "";
            }
            confirm();
            onApply?.();
          }}
          size="small"
          style={{ width: 90 }}
        >
          Limpiar
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  ...(enableLocalFilter && {
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : "",
  }),
  onFilterDropdownVisibleChange: (visible) => {
    if (visible) {
      setTimeout(() => {
        try {
          searchInput?.current?.select();
        } catch {}
      }, 100);
    }
  },
});
